import * as React from 'react';
import DataInput from '../DataInput';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';
import * as _ from 'lodash';

class SimpleTextInput extends React.Component<InputProps, {}> {
  private inputProps: DirectInputProps;
  private contextProps: DataInputContextProps;

  render() {
    const { input, placeholder, meta, label } = this.props;
    this.inputProps = {
      ...input,
      id: getIdFromName(input.name),
      placeholder,
      type: 'text',
    };

    this.contextProps = {
      label: label || '',
      error: meta.touched && meta.error,
      normalize: _.identity,
      format: _.identity,
    };

    return (
      <div className="SimpleTextInput">
        <DataInput inputProps={this.inputProps} contextProps={this.contextProps} />
      </div>
    );
  }
}

export const SimpleTextInputConfig = {
  component: SimpleTextInput,
};

export default SimpleTextInput;
